import { call, put, takeLeading } from 'redux-saga/effects'
import {
  COURSE_REQUEST,
  COURSE_SUCCESS,
  COURSE_FAILED,
  COURSE_DETAIL_REQUEST,
  COURSE_DETAIL_SUCCESS,
  COURSE_DETAIL_FAILED,
} from "./actionTypes";
import { courseApi } from '../../api';

// 切换首页Tabbar菜单
export enum MenuList {
  Home,
  Rank,
  Mine,
}

// 获取课程列表
export function* getCourseList() {
  try {
    const response = yield call(courseApi.getCourseList)
    const data = response.data;
    const courseArr: any[] = [];
    const courseIngArr: any[] = [];
    const courseOverArr: any[] = [];
    if (data?.length > 0) {
      data?.map(item => {
        if (item.status == '结束') {
          courseOverArr.push(item);
        } else {
          courseIngArr.push(item);
        }
      })
      if (courseIngArr.length > 0) {
        var o: any = new Object();
        o.title = '播出中';
        o.flied = courseIngArr;
        courseArr.push(o);
      }
      if (courseOverArr.length > 0) {
        var o: any = new Object();
        o.title = '结束';
        o.flied = courseOverArr;
        courseArr.push(o);
      }
      yield put({
        type: COURSE_SUCCESS,
        payload: courseArr,
      })
    }
  }
  catch (e) {
    yield put({
      type: COURSE_FAILED
    })
  }
}

export function* getCourseDetail(action) {
  try {
    const response = yield call(courseApi.getCourseDetail,action.payload);
    const data = response.data[0];
    if (data) {
      yield put({
        type: COURSE_DETAIL_SUCCESS,
        payload: data,
      })
    }
  }
  catch (e) {
    yield put({
      type: COURSE_DETAIL_FAILED
    })
  }
}

export default function* commonSagas() {
  yield takeLeading(COURSE_REQUEST, getCourseList)
  yield takeLeading(COURSE_DETAIL_REQUEST, getCourseDetail)
}
